import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  getTodaySteps,
  logSteps as localLogSteps,
  getStepGoal,
  saveStepGoal as localSaveStepGoal,
  getWeekSteps,
} from '../utils/scheduleData';
import {
  fsGetTodaySteps,
  fsLogSteps,
  fsGetStepGoal,
  fsSaveStepGoal,
  fsGetWeekSteps,
} from '../services/firestoreDb';

export function useSteps() {
  const { user } = useAuth();
  const uid = user?.id;

  const [todaySteps, setTodaySteps] = useState(() => getTodaySteps());
  const [stepGoal, setStepGoal] = useState(() => getStepGoal());
  const [weekSteps, setWeekSteps] = useState(() => getWeekSteps());

  useEffect(() => {
    if (!uid) return;
    Promise.all([fsGetTodaySteps(uid), fsGetStepGoal(uid), fsGetWeekSteps(uid)])
      .then(([s, g, w]) => {
        if (s !== null) setTodaySteps(s);
        if (g !== null) setStepGoal(g);
        if (w !== null) setWeekSteps(w);
      })
      .catch((err) => console.warn('[useSteps] Failed to load from Firestore:', err));
  }, [uid]);

  const logSteps = useCallback(
    async (count) => {
      localLogSteps(count);
      setTodaySteps(count);
      setWeekSteps(getWeekSteps());
      if (uid) await fsLogSteps(uid, count).catch((err) => console.warn('[useSteps] Log failed:', err));
    },
    [uid]
  );

  const saveStepGoal = useCallback(
    async (goal) => {
      localSaveStepGoal(goal);
      setStepGoal(goal);
      if (uid) await fsSaveStepGoal(uid, goal).catch((err) => console.warn('[useSteps] Goal save failed:', err));
    },
    [uid]
  );

  return { todaySteps, stepGoal, weekSteps, logSteps, saveStepGoal };
}
